<div class="flex flex-col pin-container pin-gradient-background">
  <div class="header-container container">
    <pin-new-header type="public" customClass="bg-transparent!" class="flex flex-row justify-baseline items-center"></pin-new-header>
  </div>
  <div class="flex justify-center w-full pt-10">
    <pin-card class="w-2/5" customClass="flex items-center">
      <pin-card-title [centered]="true" icon="person_outline" customClass="heading-lg-bold">
        @if (isSessionExpired) {
          You have been logged out due to inactivity.
        } @else {
          You have been logged out.
        }
      </pin-card-title>
    </pin-card>
  </div>
  <div class="footer--main">
    <pin-footer type="public" customClass="white-color"></pin-footer>
  </div>
</div>
